import { useEffect } from 'react';

export function useMountEffect(cb: () => void | (() => void)) {
  useEffect(cb, []);
}
